import * as HttpService from "./http.service";
import { GET_CATEGORIES_URL } from "./url.service";

export const getAllCategories = (name) => {
    if (name.split(" ").length) {
        name = name.split(" ").join("%20");
    }
    return HttpService.getWithOutAuth(GET_CATEGORIES_URL(name));
};
